interface Props {
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
}

const Complete = ({
  fill = '#00c13c',
  width = '46',
  height = '46',
  className,
}: Props) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 46 46"
    className={className}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M 22.99 46 C 10.31 46 -0.01 35.68 -0.01 23 C -0.01 10.33 10.31 0.01 22.99 0.01 C 35.66 0.01 45.98 10.33 45.98 23 C 45.98 35.68 35.66 46 22.99 46 Z M 22.99 2.29 C 11.56 2.29 2.27 11.58 2.27 23 C 2.27 34.43 11.56 43.72 22.99 43.72 C 34.41 43.72 43.7 34.43 43.7 23 C 43.7 11.58 34.41 2.29 22.99 2.29 Z M 20.46 33.44 C 20.46 33.44 12.81 24.61 12.81 24.61 C 12.4 24.13 12.45 23.41 12.93 23 C 13.4 22.59 14.12 22.64 14.53 23.12 C 14.53 23.12 20.34 29.83 20.34 29.83 C 20.34 29.83 32.53 13.68 32.53 13.68 C 32.91 13.18 33.62 13.08 34.13 13.46 C 34.63 13.84 34.73 14.55 34.35 15.05 C 34.35 15.05 20.46 33.44 20.46 33.44 Z"
    />
  </svg>
);

export default Complete;
